exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon-stage{display:inline-block;margin-right:5px}.icon-stage .icon-box.s{font-size:14px}.icon-stage .icon-box.m{font-size:16px}.icon-stage .icon-box.l{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/base/icon/icon.scss
// module id = 570
// module chunks = 2